import { Grid, Tooltip } from "@material-ui/core";
import { useGetUsersQuery } from "features/users/usersSlice";
import { IssueUserStyle } from "./style";
import { arrayToObject } from "utils/object-util";
import stc from 'string-to-color';
import { orderBy } from "lodash";

export const IssueTrackerUser = ({ userId, iconOnly }) => {
    const classes = IssueUserStyle();
    let { data: users, error: usersError, isLoading: isLoadingUsers } = useGetUsersQuery();

    const userLookup = arrayToObject(users);

    const outOfOrgText = "Assigned to a user that is not visible to you";

    return (<>
        {!!userId && <Tooltip title={userLookup?.[userId]?.name ?? outOfOrgText}>
            <Grid container alignItems="center" >
                <Grid item className={classes.userInitials} style={{ background: userLookup?.[userId]?.initials && stc(userLookup?.[userId]?.name) }}>{userLookup?.[userId]?.initials}</Grid>
                {!iconOnly && <Grid item className={classes.userName}> {userLookup?.[userId]?.name}</Grid>}
            </Grid>
        </Tooltip>}
    </>
    )
}